"use client";
import React, { useRef } from 'react';
import data from './data.json';
import { useDraggable } from "react-use-draggable-scroll";
import { Link } from 'react-router-dom';
import { InfiniteSlider } from '@/components/motion-primitives/infinite-slider';
import { toast } from "sonner";

export default function RealProjectsThumbSm() {
    const ref = useRef();
    const { events } = useDraggable(ref);

    return (
        <div className='w-full overflow-x-scroll' {...events} ref={ref}>
            <InfiniteSlider gap={12} speedOnHover={1}>
                {data.realProjects.map((projectExp) => {
                    const isPlaceholder = projectExp.link === "/#";

                    const handleClick = (e) => {
                        e.preventDefault();
                        toast("Still writing...", {
                            description: `${projectExp.projectname} is not yet available.`,
                            duration: 3000,
                        });
                    };

                    return (
                        <div
                            key={projectExp.id}
                            className='flex flex-col gap-y-2 grayscale-0 hover:saturate-200 hover:scale-[1.02] transition-all duration-300 ease-in-out'
                        >
                            {isPlaceholder ? (
                                <div
                                    onClick={handleClick}
                                    className='cursor-pointer relative flex-shirk-0 w-auto justify-center overflow-y-hidden'
                                >
                                    <img
                                        src={projectExp.src}
                                        className='w-auto h-[240px] border rounded-2xl'
                                    />
                                </div>
                            ) : (
                                <Link
                                    to={projectExp.link}
                                    className='relative flex-shirk-0 w-auto justify-center overflow-y-hidden'
                                >
                                    <img
                                        src={projectExp.src}
                                        className='w-auto h-[240px] border rounded-2xl'
                                    />
                                </Link>
                            )}
                        </div>
                    );
                })}
            </InfiniteSlider>
        </div>
    );
}
